import { DailyStats } from '../../../../providers/portfolio-performance/compute-daily-stats';
import './styles.scss';

interface DailyReturnStatsBandProps {
  stats: DailyStats;
}

const formatPct = (value: number | null): string =>
  value === null ? '-' : `${value >= 0 ? '+' : ''}${(value * 100).toFixed(2)}%`;

const formatDayCount = (count: number, total: number): string =>
  total > 0 ? `${count} (${((count / total) * 100).toFixed(1)}%)` : String(count);

const StatTile = ({ label, value }: { label: string; value: string }) => (
  <div className="daily-return-stat-tile">
    <span className="daily-return-stat-label">{label}</span>
    <span className="daily-return-stat-value">{value}</span>
  </div>
);

export const DailyReturnStatsBand = ({ stats }: DailyReturnStatsBandProps) => {
  const totalDays = stats.positiveDays + stats.negativeDays;

  return (
    <div className="daily-return-stats-band">
      <StatTile label="Positive Days" value={formatDayCount(stats.positiveDays, totalDays)} />
      <StatTile label="Negative Days" value={formatDayCount(stats.negativeDays, totalDays)} />
      <StatTile label="Avg Win" value={formatPct(stats.avgWin)} />
      <StatTile label="Avg Loss" value={formatPct(stats.avgLoss)} />
      <StatTile label="VaR (95%)" value={formatPct(stats.var95)} />
      <StatTile label="CVaR (95%)" value={formatPct(stats.cvar95)} />
    </div>
  );
};
